import { get } from "../../../api/axios-client";
import { Unit } from "../models/workOrderTypes";

const controllerUrl = "api/unit/";
const DEFAULT_PAGE_SIZE = 10;

export type UnitSearchField = "serial" | "model" | "unitNumber";

export interface PaginatedUnitSearchResult {
  units: Unit[];
  pageNumber: number;
  pageSize: number;
  hasMore: boolean;
}

const mapUnitSearchResponse = (response: Record<string, unknown>): PaginatedUnitSearchResult => {
  const units = (response.units ?? response.Units ?? []) as Unit[];

  return {
    units,
    pageNumber: Number(response.pageNumber ?? response.PageNumber ?? 1),
    pageSize: Number(response.pageSize ?? response.PageSize ?? DEFAULT_PAGE_SIZE),
    hasMore: Boolean(response.hasMore ?? response.HasMore ?? false),
  };
};

export const UnitsAPI = {
  GetUnitBySearchTerm: async (
    query: string,
    locationIdentity: number,
    customerIdentity?: number | null,
    searchField?: UnitSearchField,
    pageNumber: number = 1,
    pageSize: number = DEFAULT_PAGE_SIZE,
  ): Promise<PaginatedUnitSearchResult | null> => {
    try {
      let url = `${controllerUrl}GetUnitBySearchTerm?LocationIdentity=${locationIdentity}&searchTerm=${encodeURIComponent(query)}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
      if (customerIdentity) {
        url += `&customerIdentity=${customerIdentity}`;
      }
      if (searchField) {
        url += `&searchField=${searchField}`;
      }

      const { data } = await get(url);
      const content = data.content ?? data.Content ?? data;

      if (Array.isArray(content)) {
        return {
          units: content as Unit[],
          pageNumber,
          pageSize,
          hasMore: content.length === pageSize,
        };
      }

      return mapUnitSearchResponse(content as Record<string, unknown>);
    } catch (err) {
      return null;
    }
  },
};
